import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";
import { massUpdateProductStatus } from "../services/productsService"; // Імпортуємо наш новий сервіс
import { useErrorStore } from "components";

// Глобальний стор (state manager) для режиму вибору SKU товарів
export const useProductsSelectionStore = create(
  persist(
    (set, get) => ({
      isSelectionModeActive: false,
      selectedSkus: [],
      isLoading: false,

      // Переключення режиму вибору
      toggleSelectionMode: () =>
        set((state) => {
          const newMode = !state.isSelectionModeActive;
          return {
            isSelectionModeActive: newMode,
            selectedSkus: newMode ? state.selectedSkus : [], // Очищаємо при виході
          };
        }),

      // Додавання або видалення одного SKU (toggle)
      toggleSku: (sku) =>
        set((state) => {
          const isSelected = state.selectedSkus.includes(sku);
          if (isSelected) {
            return { selectedSkus: state.selectedSkus.filter((s) => s !== sku) };
          } else {
            return { selectedSkus: [...state.selectedSkus, sku] };
          }
        }),

      // Функція для "Обрати всі" на сторінці
      selectAll: (allSkusOnPage) => {
        set((state) => {
          const allSelected = allSkusOnPage.every((sku) =>
            state.selectedSkus.includes(sku)
          );

          if (allSelected) {
            // Якщо всі вибрані - знімаємо виділення
            return {
              selectedSkus: state.selectedSkus.filter(
                (s) => !allSkusOnPage.includes(s)
              ),
            };
          } else {
            // Якщо не всі - додаємо невибрані
            const newSet = new Set([...state.selectedSkus, ...allSkusOnPage]);
            return { selectedSkus: Array.from(newSet) };
          }
        });
      },

      // Масове оновлення статусу (Update Status)
      updateStatusForSelected: async (updateStatus) => {
        const { selectedSkus } = get();
        if (selectedSkus.length === 0) return;

        set({ isLoading: true });
        try {
          // Викликаємо сервіс масового оновлення продуктів
          const response = await massUpdateProductStatus(selectedSkus, updateStatus);

          // Скидаємо вибір після успішного оновлення
          get().resetState();

          return response;
        } catch (error) {
          const { showError } = useErrorStore.getState();
          showError(`Не вдалося оновити статус: ${error.message}`);
          console.error("Помилка масового оновлення:", error);
          throw error;
        } finally {
          set({ isLoading: false });
        }
      },

      // Скидання стану
      resetState: () =>
        set({
          isSelectionModeActive: false,
          selectedSkus: [],
          isLoading: false,
        }),
    }),
    {
      name: "products-selection-storage", // Унікальний ключ для LocalStorage
      storage: createJSONStorage(() => localStorage),
      partialize: (state) => ({
        // Зберігаємо лише галочки та режим
        selectedSkus: state.selectedSkus,
        isSelectionModeActive: state.isSelectionModeActive,
      }),
    }
  )
);
